import { render, staticRenderFns } from "./Congratulations.vue?vue&type=template&id=0dd93876&scoped=true"
import script from "./Congratulations.vue?vue&type=script&lang=js"
export * from "./Congratulations.vue?vue&type=script&lang=js"
import style0 from "./Congratulations.vue?vue&type=style&index=0&id=0dd93876&prod&lang=scss&scoped=true"
import style1 from "./Congratulations.vue?vue&type=style&index=1&id=0dd93876&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd93876",
  null
  
)

export default component.exports